import { can } from "./can"

export const isTestSupportEnabled = (
  environment = import.meta.env.CLOUDFLARE_ENV,
) => environment !== "production"

export const canAccessTestSupport = (
  environment = import.meta.env.CLOUDFLARE_ENV,
) => isTestSupportEnabled(environment) && can("read", "testSupport")
